/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveSchema } from "./reserveSchema.ts";

export const orgUnitReserveCancelCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReserveCancelCreatePathReserveIdSchema = z.uuid();

export const orgUnitReserveCancelCreateStatus200Schema = reserveSchema;

export const orgUnitReserveCancelCreateResponseSchema = orgUnitReserveCancelCreateStatus200Schema;
